import React, { PureComponent } from 'react';
import b from 'b_';

import './event-item-horizontal.stub.css';

import Rect from '@components/rect';

const class_ = b.with('event-item-horizontal-stub');

export default class EventItemHorizontalStub extends PureComponent {
    public render() {
        return (
            <div className={class_()}>
                <Rect
                    className={class_('image')}
                    width={220}
                    height={150}
                />
                <div className={class_('info')}>
                    <Rect
                        className={class_('title')}
                        width={'100%'}
                        height={50}
                        type="black"
                    />
                    <Rect
                        className={class_('description')}
                        width={'100%'}
                        height={60}
                    />
                    <Rect
                        className={class_('bottom')}
                        width={150}
                        height={20}
                    />
                </div>
            </div>
        );
    }
}
